var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "j-modal",
    {
      attrs: {
        title: _vm.title,
        width: 800,
        visible: _vm.visible,
        confirmLoading: _vm.confirmLoading,
        switchFullscreen: "",
        cancelText: "关闭",
      },
      on: { ok: _vm.handleOk, cancel: _vm.handleCancel },
    },
    [
      _c(
        "a-spin",
        { attrs: { spinning: _vm.confirmLoading } },
        [
          _c(
            "a-form-model",
            {
              ref: "form",
              attrs: { model: _vm.model, rules: _vm.validatorRules },
            },
            [
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "classId",
                    label: "班级名称",
                  },
                },
                [
                  _c("j-dict-select-tag", {
                    attrs: {
                      dictCode: "school_class,name,id,delete_flag=0",
                      placeholder: "请选择班级名称",
                    },
                    model: {
                      value: _vm.model.classId,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "classId", $$v)
                      },
                      expression: "model.classId",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "content",
                    label: "活动内容",
                  },
                },
                [
                  _c("a-textarea", {
                    attrs: { rows: "4", placeholder: "请输入活动内容" },
                    model: {
                      value: _vm.model.content,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "content", $$v)
                      },
                      expression: "model.content",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "picUrl",
                    label: "活动图片",
                  },
                },
                [
                  _c("j-image-upload", {
                    attrs: { text: "上传活动图片", isMultiple: true },
                    model: {
                      value: _vm.model.picUrl,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "picUrl", $$v)
                      },
                      expression: "model.picUrl",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "videoUrl",
                    label: "视频链接",
                  },
                },
                [
                  _c("j-upload", {
                    attrs: { placeholder: "请输入样例文本内容" },
                    model: {
                      value: _vm.model.videoUrl,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "videoUrl", $$v)
                      },
                      expression: "model.videoUrl",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "visible",
                    label: "是否给家长可见",
                  },
                },
                [
                  _c("j-dict-select-tag", {
                    attrs: { dictCode: "visible_status" },
                    model: {
                      value: _vm.model.visible,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "visible", $$v)
                      },
                      expression: "model.visible",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }